export function extractFormData($form) {
    return [...$form.elements]
        .reduce((acc, input) => ({
            ...acc,
            [input.name]: input.value
        }), {})
}